import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import useStyles from "./styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// HINT: classic dialog box with a slide-up transition
// contents of dialog must be passed in this way -
// const dialogContent = (
//   <Component> </Component>
// );
export default function SlideUpDialog(props) {
  const classes = useStyles();

  return (
    <span>
      <Dialog
        className={classes.slideUpDialog}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={props.handleClose}
        fullWidth={true}
        maxWidth={"md"}
      >
        <Grid component="form" container className={classes.slideUpDialogGrid}>
          <Grid container className={classes.title}>
            <Typography variant="h2">{props.title}</Typography>
            {props.reported ? (
              <Typography>
                Da Segnalazione:
                <span style={{ color: "#008ab8" }}> {props.reported}</span>
              </Typography>
            ) : null}
          </Grid>
          <Grid container className={classes.formContainer}>
            {props.children}
          </Grid>
        </Grid>
      </Dialog>
    </span>
  );
}
